import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import successImg from "../../assets/images/userprofile/successImg.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { axiosInstance_user } from "../../axiosInstance-user";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { toast, ToastContainer } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";

import { useNavigate } from "react-router-dom";

const animatedComponents = makeAnimated();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  border: "1px solid white",
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};
// knownLaguages styles
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: "100%",
    padding: "2px", // Slight padding only for inside control
    border: "1px solid #e4e4e4",
    backgroundColor: "#fbfbfb",
    color: "#2a2a2a",
    borderRadius: "10px",
    fontSize: "16px",
    fontWeight: 400,
    boxShadow: state.isFocused ? "0 0 0 1px #e4e4e4" : "none",
    "&:hover": {
      borderColor: "#ccc",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#e4e4e4"
      : state.isFocused
      ? "#f2f2f2"
      : "#fff",
    color: "#2a2a2a",
    fontSize: "16px",
    fontWeight: 400,
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#e0e0e0",
    borderRadius: "5px",
    padding: "2px 4px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#2a2a2a",
    fontSize: "14px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#2a2a2a",
    ":hover": {
      backgroundColor: "#d3d3d3",
      color: "#000",
    },
  }),
};

const otherInfoSchema = Yup.object().shape({
  // lite_logins: Yup.string().required("Lite Logins are required"),
  // known_languages: Yup.string().required("Known Languages are required"),
  about_family: Yup.string().required("About Family is required"),
  about_career: Yup.string().required("About Career is required"),
  nationality: Yup.string().required("Nationality is required"),
  complexion: Yup.string().required("Complexion is required"),
  drinking: Yup.string().required("Drinking preference is required"),
  smoking: Yup.string().required("Smoking preference is required"),
  diet: Yup.string().required("Diet preference is required"),
  pets: Yup.string().required("Pets preference is required"),
  talents: Yup.string().required("Talents are required"),

  // wanderlust: Yup.boolean().oneOf(
  //   [true],
  //   "Please confirm if wanderlust"
  // ),
});

export function OtherInfo() {
  const [loading, setLoading] = useState(false);

  //  const [religion, setReligion] = useState([]);
  const [knownLaguages, setKnownLaguages] = useState([]);
  const [nationality, setNationality] = useState([]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const navigate = useNavigate();

  // const formik = useFormik({
  //   initialValues: {
  //     lite_logins: [],
  //     known_languages: [],
  //     about_family: "",
  //     about_career: "",
  //     nationality: "",
  //     complexion: "",
  //     drinking: "",
  //     smoking: "",
  //     diet: "",
  //     pets: "",
  //     talents: "",
  //     wanderlust: false,
  //   },
  //   validationSchema: otherInfoSchema,
  //   onSubmit: async (values) => {
  //     try {
  //       setLoading(true);
  //       const dataToSave = {
  //         profile: {
  //           // lite_logins: values.lite_logins
  //           //   .split(",")
  //           //   .map((item) => item.trim())
  //           //   .filter((item) => item !== ""),
  //           lite_logins: Array.isArray(values.lite_logins)
  //             ? values.lite_logins
  //             : (values.lite_logins || "")
  //                 .split(",")
  //                 .map((item) => item.trim())
  //                 .filter((item) => item !== ""),

  //           // known_languages: values.known_languages.map((lang) => lang.value),
  //           known_languages: (values.known_languages || [])
  //             .map((lang) => lang?.value)
  //             .filter((val) => val != null), // filter and don't send null to array

  //           about_family: values.about_family,
  //           about_career: values.about_career,
  //           complexion: Number(values.complexion),
  //           diet: Number(values.diet),
  //           drinking: Number(values.drinking),
  //           pets: Number(values.pets),
  //           smoking: Number(values.smoking),
  //           nationality: Number(values.nationality),
  //           talents: values.talents,
  //           wanderlust: values.wanderlust,
  //         },
  //       };

  //       localStorage.setItem("otherDetails", JSON.stringify(dataToSave));

  //       const basicDetails = JSON.parse(
  //         localStorage.getItem("basicDetails") || "{}"
  //       );
  //       const familyDetails = JSON.parse(
  //         localStorage.getItem("familyDetails") || "{}"
  //       );
  //       const educationDetails = JSON.parse(
  //         localStorage.getItem("educationDetails") || "{}"
  //       );
  //       const otherDetails = JSON.parse(
  //         localStorage.getItem("otherDetails") || "{}"
  //       );
  //       const documentDetails = JSON.parse(
  //         localStorage.getItem("documentDetails") || "{}"
  //       );
  //       //Convert base64 to file and append
  //       // Helper to convert base64 to Blob
  //       const dataURLtoBlob = (dataURL) => {
  //         const arr = dataURL.split(",");
  //         const mime = arr[0].match(/:(.*?);/)[1];
  //         const bstr = atob(arr[1]);
  //         let n = bstr.length;
  //         const u8arr = new Uint8Array(n);
  //         while (n--) {
  //           u8arr[n] = bstr.charCodeAt(n);
  //         }
  //         return new Blob([u8arr], { type: mime });
  //       };

  //       const formData = new FormData();

  //       // Append regular fields
  //       // const allData = {
  //       //   ...basicDetails,
  //       //   ...familyDetails,
  //       //   ...educationDetails,
  //       //   ...otherDetails,
  //       // };
  //       const allData = {
  //         ...basicDetails,
  //         ...familyDetails,
  //         ...educationDetails,
  //         profile: {
  //           ...(basicDetails.profile || {}),
  //           ...(otherDetails.profile || {}),
  //           ...(familyDetails.profile || {}),
  //           ...(educationDetails.profile || {}),
  //         },
  //       };

  //       const appendFormData = (formData, data, parentKey = "") => {
  //         Object.entries(data).forEach(([key, value]) => {
  //           const formKey = parentKey ? `${parentKey}[${key}]` : key;

  //           // If array and this key needs to be stringified as JSON
  //           if (
  //             (key === "known_languages" ||
  //               key === "lite_logins" ||
  //               key === "social_media") &&
  //             Array.isArray(value)
  //           ) {
  //             formData.append(formKey, JSON.stringify(value));
  //           } else if (
  //             value !== null &&
  //             typeof value === "object" &&
  //             !Array.isArray(value) &&
  //             !(value instanceof Blob)
  //           ) {
  //             appendFormData(formData, value, formKey);
  //           } else if (Array.isArray(value)) {
  //             // default fallback (if needed elsewhere)
  //             formData.append(formKey, value.join(","));
  //           } else {
  //             formData.append(formKey, value);
  //           }
  //         });
  //       };

  //       // Use this instead of your existing loop
  //       appendFormData(formData, allData);

  //       // Append files (base64 to Blob)
  //       const fileFields = [
  //         "payslip",
  //         "passport",
  //         "education_document",
  //         "aadhar_or_pan",
  //         "pic_with_front_cam",
  //       ];
  //       for (const field of fileFields) {
  //         const base64 = documentDetails?.profile?.[field];
  //         if (base64) {
  //           const blob = dataURLtoBlob(base64);
  //           formData.append(`profile[${field}]`, blob, `${field}.jpg`);
  //         }
  //         const verified = documentDetails?.profile?.[`${field}_verified`];
  //         if (verified) {
  //           formData.append(`profile[${field}_verified]`, verified);
  //         }
  //       }

  //       // Submit using multipart/form-data
  //       const response = await axiosInstance_user.post(
  //         "/users-profiles/",
  //         formData,
  //         {
  //           headers: {
  //             "Content-Type": "multipart/form-data",
  //           },
  //         }
  //       );

  //       if (response.data?.status === "success") {
  //         setLoading(false); // Stop loader first
  //         handleOpen();
  //         setTimeout(() => {
  //           navigate("/user-profiles");
  //           localStorage.removeItem("basicDetails");
  //           localStorage.removeItem("familyDetails");
  //           localStorage.removeItem("educationDetails");
  //           localStorage.removeItem("otherDetails");
  //           localStorage.removeItem("documentDetails");
  //         }, 1500);
  //       } else if (response.data?.status === "error") {
  //         toast.error(
  //           response?.data?.message || "Please try again,Something went wrong!"
  //         );
  //         // toast.error("Please try again,Something went wrong! ");
  //       }
  //     } catch (error) {
  //       // catch (error) {
  //       //   setLoading(false);
  //       //   toast.error(error.response?.data?.message || "Please try again,Something went wrong!");
  //       //   // toast.error("Please try again,Something went wrong! ");
  //       //   // localStorage.removeItem("basicDetails");
  //       //   // localStorage.removeItem("familyDetails");
  //       //   // localStorage.removeItem("educationDetails");
  //       //   // localStorage.removeItem("otherDetails");
  //       //   // localStorage.removeItem("documentDetails");

  //       //   console.error("Error submitting profile:", error);
  //       //   // setTimeout(() => {
  //       //   //   // Force page reload
  //       //   //   window.location.reload();
  //       //   // }, 3000);
  //       // }
  //       console.error("Submission error:", error);
  //       if (error.response) {
  //         console.error("Response data:", error.response.data);
  //         console.error("Response status:", error.response.status);
  //         console.error("Response headers:", error.response.headers);
  //         const message = error.response.data?.message || "Submission failed.";
  //         toast.error(message);
  //         alert(`Error 400: ${JSON.stringify(error.response.data, null, 2)}`);
  //       } else if (error.request) {
  //         console.error(
  //           "Request made but no response received:",
  //           error.request
  //         );
  //         toast.error("No response from server.");
  //       } else {
  //         console.error("Error setting up request:", error.message);
  //         toast.error("Something went wrong.");
  //       }
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  // });

  // useEffect(() => {
  //   const otherDetails = localStorage.getItem("otherDetails");
  //   if (otherDetails) {
  //     try {
  //       const parsedData = JSON.parse(otherDetails);
  //       formik.setValues({
  //         ...parsedData,
  //         lite_logins: parsedData.lite_logins?.join(", ") || "",
  //         known_languages: knownLaguages || [],
  //       });
  //     } catch (err) {
  //       console.error("Error parsing saved data:", err);
  //     }
  //   }
  // }, []);

  const formik = useFormik({
    initialValues: {
      lite_logins: [],
      known_languages: [],
      about_family: "",
      about_career: "",
      nationality: "",
      complexion: "",
      drinking: "",
      smoking: "",
      diet: "",
      pets: "",
      talents: "",
      wanderlust: false,
    },
    validationSchema: otherInfoSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const dataToSave = {
          profile: {
            // lite_logins: values.lite_logins
            //   .split(",")
            //   .map((item) => item.trim())
            //   .filter((item) => item !== ""),
            lite_logins: Array.isArray(values.lite_logins)
              ? values.lite_logins
              : (values.lite_logins || "")
                  .split(",")
                  .map((item) => item.trim())
                  .filter((item) => item !== ""),

            // known_languages: values.known_languages.map((lang) => lang.value),
            known_languages: (values.known_languages || [])
              .map((lang) => lang?.value)
              .filter((val) => val != null), // filter and don't send null to array

            about_family: values.about_family,
            about_career: values.about_career,
            complexion: Number(values.complexion),
            diet: Number(values.diet),
            drinking: Number(values.drinking),
            pets: Number(values.pets),
            smoking: Number(values.smoking),
            nationality: Number(values.nationality),
            talents: values.talents,
            wanderlust: values.wanderlust,
          },
        };
        localStorage.setItem("otherDetails", JSON.stringify(dataToSave));
        handleOpen();
        setTimeout(() => {
          handleClose();
        },2000);
      } catch (error) {
        console.error("Error setting up request:", error.message);
        toast.error("Something went wrong.");
      } finally {
        setLoading(false);
      }
    },
  });

  async function LoadKnownLanguages() {
    try {
      const response = await axiosInstance_user.get("/dropdown/choices");

      if (response.status === 200 && response.data) {
        // react-select expects this format for each option eg. { value: 'someValue', label: 'Display Label' }
        const languages = response.data.mother_tongue.map((lang) => ({
          value: lang.id,
          label: lang.name,
        }));
        setKnownLaguages(languages);
      } else {
        console.error("Unexpected response format or status", response);
      }
    } catch (error) {
      console.error("Failed to load religion data:", error.message);
    }
  }
  useEffect(() => {
    LoadKnownLanguages();
  }, []);
  const handleChange = (selectedOptions) => {
    formik.setFieldValue("known_languages", selectedOptions || []);
  };
  async function LoadNationality() {
    try {
      const response = await axiosInstance_user.get("/dropdown/country");
      setNationality(response.data);
    } catch (error) {
      console.error("Failed to load nationality data:", error.message);
    }
  }
  useEffect(() => {
    LoadNationality();
  }, []);
  // get and set form data from localStorage to fields
  useEffect(() => {
    if (knownLaguages.length > 0) {
      // wait until knownLanguages options are loaded
      const otherDetails = localStorage.getItem("otherDetails");
      if (otherDetails) {
        const parsed = JSON.parse(otherDetails);
        const profile = parsed.profile || {};

        // Map known_languages IDs to full option objects {value, label}
        const selectedKnownLanguages = (profile.known_languages || [])
          .map((id) => knownLaguages.find((lang) => lang.value === id))
          .filter(Boolean); // remove undefined if any

        formik.setValues({
          ...formik.initialValues,
          lite_logins: Array.isArray(profile.lite_logins)
            ? profile.lite_logins.join(", ")
            : "",
          known_languages: selectedKnownLanguages,
          about_family: profile.about_family || "",
          about_career: profile.about_career || "",
          complexion: profile.complexion?.toString() || "",
          diet: profile.diet?.toString() || "",
          drinking: profile.drinking?.toString() || "",
          pets: profile.pets?.toString() || "",
          smoking: profile.smoking?.toString() || "",
          nationality: profile.nationality?.toString() || "",
          talents: profile.talents || "",
          wanderlust: !!profile.wanderlust,
        });
      }
    }
  }, [knownLaguages]);

  return (
    <form onSubmit={formik.handleSubmit}>
      {loading && (
        <div className="loader-overlay">
          <CircularProgress style={{ color: "#f24464" }} />
        </div>
      )}
      <div>
        {/* Row 1 */}
        <div className="other-subcontainer">
          <div>
            <div className="other-label">Lite Logins</div>
            <div className="other-input">
              <input
                type="text"
                name="lite_logins"
                placeholder="Enter comma-separated values"
                value={formik.values.lite_logins}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.lite_logins && formik.errors.lite_logins && (
                <div className="text-danger">{formik.errors.lite_logins}</div>
              )}
            </div>
          </div>
          <div>
            <div className="other-label">Known Languages</div>

            <div className="other-input">
              {/* <input
                type="text"
                name="known_languages"
                placeholder="Enter known languages"
                value={formik.values.known_languages}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              /> */}
              <Select
                closeMenuOnSelect={false}
                components={animatedComponents}
                isMulti
                name="known_languages"
                options={knownLaguages}
                value={formik.values.known_languages}
                onChange={handleChange}
                onBlur={() => formik.setFieldTouched("known_languages", true)}
                styles={customStyles}
              />

              {formik.touched.known_languages &&
                formik.errors.known_languages && (
                  <div className="text-danger">
                    {formik.errors.known_languages}
                  </div>
                )}
            </div>
          </div>
        </div>

        {/* Row 2 */}
        <div className="other-subcontainer">
          <div>
            <div className="other-label">
              About Family <span className="text-danger">*</span>
            </div>
            <div className="other-input">
              <textarea
                name="about_family"
                placeholder="Type Here"
                rows={4}
                value={formik.values.about_family}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              ></textarea>
              {formik.touched.about_family && formik.errors.about_family && (
                <div className="text-danger">{formik.errors.about_family}</div>
              )}
            </div>
          </div>
          <div>
            <div className="other-label">
              About Career <span className="text-danger">*</span>
            </div>
            <div className="other-input">
              <textarea
                name="about_career"
                placeholder="Type Here"
                rows={4}
                value={formik.values.about_career}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              ></textarea>
              {formik.touched.about_career && formik.errors.about_career && (
                <div className="text-danger">{formik.errors.about_career}</div>
              )}
            </div>
          </div>
        </div>

        {/* Row 3 */}
        <div className="other-subcontainer">
          <div>
            <div className="other-label">
              Nationality <span className="text-danger">*</span>
            </div>
            <div className="other-input">
              <select
                name="nationality"
                id="nationality"
                value={formik.values.nationality}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  formik.setFieldValue("nationality", selectedId);
                }}
                onBlur={formik.handleBlur}
                className={`dropdown-btnBasic ${
                  formik.touched.nationality && formik.errors.nationality
                    ? "error"
                    : ""
                }`}
              >
                <option value="" disabled>
                  Select Nationality
                </option>
                {nationality.map((list) => (
                  <option value={list.id} key={list.id}>
                    {list.name}
                  </option>
                ))}
              </select>
              {formik.touched.nationality && formik.errors.nationality && (
                <div className="text-danger">{formik.errors.nationality}</div>
              )}
            </div>
          </div>
          <div>
            <div className="other-label">
              Complexion <span className="text-danger">*</span>
            </div>
            <div className="other-input">
              <select
                className="dropdown-btnOther"
                name="complexion"
                value={formik.values.complexion}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="" selected disabled>
                  Select
                </option>
                <option value="1">Fair</option>
                <option value="2">Light</option>
                <option value="3">Medium</option>
                <option value="4">Olive</option>
                <option value="5">Brown</option>
                <option value="6">Dark</option>
              </select>
              {formik.touched.complexion && formik.errors.complexion && (
                <div className="text-danger">{formik.errors.complexion}</div>
              )}
            </div>
          </div>
        </div>

        {/* Row 4 */}
        <div className="other-subcontainer">
          <div>
            <div className="other-label">
              Drinking <span className="text-danger">*</span>
            </div>
            <select
              className="dropdown-btnOther"
              name="drinking"
              value={formik.values.drinking}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" selected disabled>
                Select
              </option>
              <option value="1">Non Drinker</option>
              <option value="2">Regular</option>
              <option value="3">Planning to quit</option>
              <option value="4">Socially</option>
              <option value="5">Occasionally</option>
            </select>
            {formik.touched.drinking && formik.errors.drinking && (
              <div className="text-danger">{formik.errors.drinking}</div>
            )}
          </div>
          <div>
            <div className="other-label">
              Smoking <span className="text-danger">*</span>
            </div>
            <select
              className="dropdown-btnOther"
              name="smoking"
              value={formik.values.smoking}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" selected disabled>
                Select
              </option>
              <option value="1">Yes</option>
              <option value="2">No</option>
              <option value="3">Planning to quit</option>
              <option value="4">Occasionally</option>
              <option value="5">Regularly</option>
            </select>
            {formik.touched.smoking && formik.errors.smoking && (
              <div className="text-danger">{formik.errors.smoking}</div>
            )}
          </div>
        </div>

        {/* Row 5 */}
        <div className="other-subcontainer">
          <div>
            <div className="other-label">
              Diet <span className="text-danger">*</span>
            </div>
            <select
              className="dropdown-btnOther"
              name="diet"
              value={formik.values.diet}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" selected disabled>
                Select
              </option>
              <option value="1">Vegetarian</option>
              <option value="2">Non Vegetarian</option>
              <option value="3">Eggetarian</option>
              <option value="4">Vegan</option>
            </select>
            {formik.touched.diet && formik.errors.diet && (
              <div className="text-danger">{formik.errors.diet}</div>
            )}
          </div>
          <div>
            <div className="other-label">
              Pets <span className="text-danger">*</span>
            </div>
            <select
              className="dropdown-btnOther"
              name="pets"
              value={formik.values.pets}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" selected disabled>
                Select
              </option>
              <option value="1">Don't want</option>
              <option value="2">Cats</option>
              <option value="3">Have pets</option>
              <option value="4">Undecided</option>
            </select>
            {formik.touched.pets && formik.errors.pets && (
              <div className="text-danger">{formik.errors.pets}</div>
            )}
          </div>
        </div>

        {/* Row 6 */}
        <div className="other-subcontainer">
          <div>
            <div className="other-label">
              Talents <span className="text-danger">*</span>
            </div>
            <div className="other-input">
              <input
                type="text"
                name="talents"
                placeholder="Enter Talents"
                value={formik.values.talents}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.talents && formik.errors.talents && (
                <div className="text-danger">{formik.errors.talents}</div>
              )}
            </div>
          </div>
          <div className="checkbox-container">
            <input
              type="checkbox"
              name="wanderlust"
              checked={formik.values.wanderlust}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <label className="family-label">Wanderlust</label>
            {formik.touched.wanderlust && formik.errors.wanderlust && (
              <div className="text-danger">{formik.errors.wanderlust}</div>
            )}
          </div>
        </div>

        {/* Submit Button and Modal */}
        <div className="btnBasicSave">
          <Button type="submit">Save changes</Button>
        </div>

        <Modal
          open={open}
          onClose={handleClose}
          closeAfterTransition
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
        >
          <Fade in={open}>
            <Box sx={style} className="modal-box">
              <img src={successImg} alt="Success" />
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
              >
                Thank You
              </Typography>
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                Other information saved successfully
              </Typography>
            </Box>
          </Fade>
        </Modal>
      </div>
    </form>
  );
}
